import { type CartItem, type PartialCartItem } from '../types'

type PartialCartItemSource = Partial<Pick<CartItem, 'variation_id' | 'parent_product_id' | 'sku' | 'project_code' | 'quantity'>>

/**
 * 商品快照（PDF 辨識、CSV 驗證）轉本機購物車品項，PDF 與 CSV 兩個入口共用同一條規則。
 * cartItemId 是購物車頁查 productMap 的 key：變體商品是 variation_id；非變體商品 variation_id 為 0，
 * 退回母商品 id（campaign products 對非變體商品的 id 就是商品本身的 post id）。兩者都沒有就不進購物車。
 */
export const toPartialCartItem = (source: PartialCartItemSource): PartialCartItem | null => {
  const cartItemId = source.variation_id || source.parent_product_id
  if (!cartItemId) return null
  return {
    cartItemId,
    variation_id: source.variation_id,
    parent_product_id: source.parent_product_id,
    sku: source.sku,
    project_code: source.project_code,
    quantity: source.quantity,
  }
}
